import React, { useState, useEffect, FormEvent, ChangeEvent } from 'react'
import axios from 'axios'
import { API_URL, config } from '../components/Include';
import { Alerts } from '../components/notify';
import Cookies from 'js-cookie'
import { generateNo } from '../components/GlobalFunction';
import './Register.css';
const Register =()=> {
  const [otp, setOtp] = useState(generateNo(6))
  const [step, setStep] = useState(1)

  const [applicant, setApplicant] = useState({
		code:'',
		matric_no:'',
		email_address:'',
    telephone:'',
    otp:'',
    name:'',
    is_lock:'No'
    })
    const [errors, setErrors] = useState({
      errorMessage:'',
      email_address:'',
      otp:'',
      telephone:'',
      matric_no:'',
      is_loading:false
  });



const handleChange = (event:ChangeEvent<HTMLInputElement>) =>{	
    let {name, value} = event.target;	

    if(name==='telephone'){
      value = value.replace(/[^0-9]/g, '').slice(0,11)
    }
    if(name==='otp'){
      value = value.replace(/[^0-9]/g, '').slice(0,6)
    }
    setApplicant({...applicant, [name] : value });
   setErrors({...errors, errorMessage:'', [name]:''});
}

const handleConfirm= ()=>{

  setErrors({...errors, is_loading:true})
  const fd = new FormData();
  fd.append('confirm_otp', 'No');
  fd.append('code', applicant.code);
  fd.append('matric_no', applicant.matric_no);
  fd.append('email_address', applicant.email_address);
  
		let url = API_URL+'/application/create';
		axios.post(url, fd, config).then((response:any)=>{

      handleLogin(response.data);

    }).catch((error)=>{
      Alerts('danger', error.message, 'Error')
		}).finally(()=>{
      setErrors({...errors, is_loading:false})
    })

    }



    const handleLogin =(data:any)=>{

			if(data.type ==='success'){
        Alerts('success', data.message, 'Weldone!')

        //Redirect to login page
        
  //1000 * 60 * SESSION_IDEL_MINUTES
  var inSixtyMinutes:any = Date.now() + 419 * 60 * 1000;
  var inOneMinutes:any = Date.now() + 418 * 60 * 1000;
    var inHours = new Date(new Date().getTime() + 419 * 60 * 1000);
    
     localStorage.setItem('_spexpt', inSixtyMinutes)
    localStorage.setItem('_spbexpt', inOneMinutes) 

  Cookies.set('app_spcd', data.code, {expires: inHours })
  Cookies.set('app_tcscdk', data.token, {expires: inHours })  

	window.open('/app/confirmation?ref='+applicant.code, '_self')
			
				
			}else{
        Alerts('danger', data.message, 'Something went wrong!')
			}
    }

const handleSubmit=(event: FormEvent<HTMLButtonElement>)=>{
  event.preventDefault();

  let error = {...errors}; 
  let formIsValid = true;

let msg ='This field is required';

if(!applicant.matric_no){
  error.matric_no =msg;
  formIsValid = false;
} 


if(applicant.otp !== otp){
  error.otp ='OTP does not match';
  formIsValid = false;
} 


if(!applicant.otp){
  error.otp =msg;
  formIsValid = false;
} 


if(!formIsValid){
  setErrors(error) 
  }


  if(formIsValid) {

    setErrors({...errors, is_loading:true})

  const fd = new FormData();
  
  fd.append('confirm_otp', 'Yes');
  fd.append('code', applicant.code);
  fd.append('matric_no', applicant.matric_no);
  fd.append('email_address', applicant.email_address);
  
		let url = API_URL+'/application/create';
		axios.post(url, fd, config).then((response:any)=>{

      handleLogin(response.data)
	  })
		.catch((error)=>{
      Alerts('danger', error.message, 'Error')
		}).finally(()=>{
      setErrors({...errors, is_loading:false})
    })
    }

}


const SendOTP=()=>{

  let email = applicant.email_address.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);

  if(!email){
    setErrors({...errors, email_address:'Please enter valid email address'})
    return;
  }
  if(applicant.email_address!==''){
  
    setErrors({...errors, is_loading:true})
    const fd = new FormData();
    fd.append("matric_no", applicant.matric_no);
    fd.append("email_address", applicant.email_address);
   

      let url = API_URL+'/application/existence'
    
      axios.post(url, fd, config).then(response=>{
        
          if(response.data.status===200){
              setErrors({...errors, email_address:applicant.email_address + ' already exist', is_loading:false})
              setApplicant({...applicant, email_address:''});
          }else if(response.data.status===201){

            setErrors({...errors, email_address:applicant.email_address + ' is not a valid email', is_loading:false})
            setApplicant({...applicant, email_address:''});
          
        }else if(response.data.status===203){

          //Auto login no need of OTP

        handleConfirm()

         }else if(response.data.status===204){
          setStep(2)
          setErrors({...errors, is_loading:false})
        }else{
          setErrors({...errors, email_address:response.data.message, is_loading:false})
            setErrors({...errors, is_loading:false})
          }
    })
  }else{
    setErrors({...errors, email_address:'Please enter valid email address'});
  }
}



const handleVerify=(event: FormEvent<HTMLFormElement>)=>{
  event.preventDefault();


  //Loader here
  setErrors({...errors, is_loading:true})
  const fd = new FormData();
  Object.entries(applicant).forEach(([key, value]) => {
      fd.append(key, value);
  }); 

		let url = API_URL+'/application/verify';
		axios.post(url, fd, config).then((response:any)=>{
    
			if(response.data.status_code ==='Yes'){
				setApplicant({...applicant, telephone:response.data.telephone, name:response.data.full_name, code:response.data.code, is_lock:'Yes'});
				
			}else if(response.data.status_code ==='Exist'){
				Alerts('default', response.data.message, 'Application Exist')
        setApplicant({...applicant, matric_no:'', name:'', code:'', is_lock:'No'});

			}else{
        Alerts('danger', response.data.message, 'Something went wrong')
        setApplicant({...applicant, matric_no:'', name:'', is_lock:'No'});

			}
	  })
		.catch((error)=>{
      Alerts('danger', error.message, 'Error')
		}).finally(()=>{
      setErrors({...errors, is_loading:false})
    })
} 

  return (
    <section className="register-section py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-lg rounded-lg overflow-hidden">
              <div className="row g-0">
                {/* Left side - Registration Steps */}
                <div className="col-md-5 bg-primary text-white p-4 d-flex flex-column">
                  <div className="text-center mb-4">
                    <img src="/images/logo.png" alt="EDC Logo" className="img-fluid mb-3" style={{ maxHeight: '70px' }} />
                    <h2 className="fw-bold mb-2">Student Registration</h2>
                    <p className="lead mb-4">Follow these steps to register</p>
                  </div>
                  
                  <div className="step-container">
                    <div className="step-item d-flex">
                      <div className="step-icon rounded-circle bg-white text-primary fw-bold d-flex align-items-center justify-content-center me-3">1</div>
                      <div className="step-text">
                        <p className="mb-0 fw-semibold">Enter your matriculation number and click verify</p>
                      </div>
                    </div>
                    
                    <div className="step-item d-flex">
                      <div className="step-icon rounded-circle bg-white text-primary fw-bold d-flex align-items-center justify-content-center me-3">2</div>
                      <div className="step-text">
                        <p className="mb-0 fw-semibold">Enter your email address and click send OTP</p>
                      </div>
                    </div>
                    
                    <div className="step-item d-flex">
                      <div className="step-icon rounded-circle bg-white text-primary fw-bold d-flex align-items-center justify-content-center me-3">3</div>
                      <div className="step-text">
                        <p className="mb-0 fw-semibold">Enter the OTP sent to your email and click continue</p>
                      </div>
                    </div>
                    
                    <div className="step-item d-flex">
                      <div className="step-icon rounded-circle bg-white text-primary fw-bold d-flex align-items-center justify-content-center me-3">4</div>
                      <div className="step-text">
                        <p className="mb-0 fw-semibold">Once done, you will have access to the portal</p>
                      </div>
                    </div>
                    
                    
                  </div>
                </div>
                
                {/* Right side - Registration Form */}
                <div className="col-md-7 p-4 p-lg-5 position-relative">
                  {errors.is_loading && (
                    <div className="loading-overlay">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                  
                  <div className="text-center mb-4">
                    <h2 className="fw-bold text-primary">Validate Your Studentship</h2>
                    <p className="text-muted"> Kindly fill the form below to validate your studentship</p>
                  </div>
                  
                  <form onSubmit={(e) => e.preventDefault()} className="form-step">
                    {step === 1 ? (
                      <div>
                        <div className="mb-4">
                          <div className="input-group">
                            <div className="form-floating flex-grow-1">
                              <input 
                                type="text" 
                                className={`form-control ${errors.matric_no ? 'is-invalid' : ''}`}
                                id="matric_no"
                                name="matric_no"
                                placeholder="Enter your matriculation number"
                                value={applicant.matric_no}
                                onChange={handleChange}
                                disabled={applicant.is_lock === 'Yes'}
                                autoComplete="off"
                                required
                              />
                              <label htmlFor="matric_no">Matriculation Number</label>
                            </div>
                            <button 
                              className="btn btn-primary" 
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                if (applicant.matric_no) {
                                  handleVerify(e as unknown as FormEvent<HTMLFormElement>);
                                } else {
                                  setErrors({...errors, matric_no: 'Please enter your matriculation number'});
                                }
                              }}
                              disabled={applicant.is_lock === 'Yes' || errors.is_loading}
                            >
                              {errors.is_loading ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                  Verifying...
                                </>
                              ) : (
                                <>
                                  <i className="fa fa-check-circle me-2"></i> Verify
                                </>
                              )}
                            </button>
                          </div>
                          {errors.matric_no && <div className="text-danger small mt-1">{errors.matric_no}</div>}
                        </div>
                        
                        {applicant.is_lock === 'Yes' && (
                          <div className="mb-4">
                            <div className="alert alert-success">
                              <h5 className="mb-1">Welcome! <span className="fw-bold">{applicant.name}</span></h5>
                              <p className="mb-3">Please confirm your email address below</p>
                              
                              <div className="input-group mt-2">
                                <input 
                                  type="text" 
                                  className={`form-control ${errors.email_address ? 'is-invalid' : ''}`}
                                  placeholder="e.g  admin@me.com"
                                  name="email_address"
                                  value={applicant.email_address}
                                  onChange={handleChange}
                                  autoComplete="off"
                                />
                                <button 
                                  className="btn btn-dark" 
                                  type="button"
                                  onClick={SendOTP}
                                >
                                  <i className="fa fa-mobile me-2"></i> Send OTP
                                </button>
                              </div>
                              {errors.email_address && <div className="text-danger small mt-1">{errors.email_address}</div>}
                            </div>
                          </div>
                        )}
                        
                        {!applicant.is_lock === true && (
                          <button 
                            type="submit" 
                            className="btn btn-primary w-100 py-3 fw-bold mb-3"
                            disabled={errors.is_loading}
                          >
                            {errors.is_loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Please wait...
                              </>
                            ) : 'Continue'}
                          </button>
                        )}
                      </div>
                    ) : (
                      <div>
                        <div className="form-floating mb-4">
                          <input 
                            type="text" 
                            className={`form-control ${errors.otp ? 'is-invalid' : ''}`}
                            id="otp"
                            name="otp"
                            placeholder="Enter your 6 digit OTP"
                            value={applicant.otp}
                            onChange={handleChange}
                            autoComplete="off"
                            required
                          />
                          <label htmlFor="otp">Enter 6 Digit OTP</label>
                          {errors.otp && <div className="invalid-feedback">{errors.otp}</div>}
                        </div>
                        
                        <button 
                          type="button" 
                          onClick={handleSubmit} 
                          className="btn btn-primary w-100 py-3 fw-bold mb-3"
                        >
                          Confirm OTP
                        </button>
                        
                        <button 
                          type="button" 
                          onClick={() => window.location.href = '/app/dashboard'} 
                          className="btn btn-outline-secondary w-100 py-3 fw-bold mb-3"
                        >
                          <i className="fa fa-arrow-right me-2"></i> Continue
                        </button>
                      </div>
                    )}
                    
                    <div className="text-center mt-4">
                      <p className="mb-0">Already registered? <a href="/login" className="text-primary fw-semibold">Sign in here</a></p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Register